import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionRoutes from '../../../components/permission/permissionRoutes';

const readAll = createAsyncThunk(
  'thunk/permission/readAll',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionRoutes.api.readAll, {
      body: arg?.data,
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default readAll;
